import React from "react";

const EmptyTableMessage = ({isMPorPI}) => (
  <div style={{textAlign: "left"}}>
    {isMPorPI ?
      "Bitte fügen Sie das gewünschte Produkt hinzu." :
      "Bitte fügen Sie die gewünschten Produkte hinzu."}
  </div>
)

export default EmptyTableMessage;